module.exports = __webpack_public_path__ + "img/protect.78b78aa6.svg";